import React, { useEffect, 
  // useMemo, 
  useState } from 'react';
// import { message, Spin } from 'antd';
import * as S from './styles';
//import InvestigationCardSkeleton from './InvestigationCardSkeleton';
import InvestigationTab from './InvComponents/investigations';
import StandardTab from './InvComponents/standards';
import MaterialTab from './InvComponents/materials';
import TeacherNotesTab from './InvComponents/TeacherNotesTab';
// import CustomInvestigationLoadingV2 from '../../../shared/CustomInvestigationLoadingV2';

interface InvestigationCardProps {
  data: any;
  isActive?: boolean;
  setFullScreen?: () => void;
  closeFullScreen?: () => void;
  isFavorite?: boolean;
  cardType?: string;
  cloneText?: string;
  loading?: boolean;
  action: () => void;
  actionText: string;
  available?: boolean;
  supportedStates?: { state: string; statements: string[] }[];
  isAssessment?: boolean;
  showPreview?: boolean;
  isAdvancedSearch?: boolean;
  actionDisabled?: boolean;
  isTeacher?: boolean;
}
const InvestigationListPageCard: React.FC<InvestigationCardProps> = ({
  data,
  isActive,
  closeFullScreen,
  setFullScreen,
  cloneText,
  actionText,
  action,
  available = true,
  isAssessment = false,
  showPreview = false,
  isAdvancedSearch = false,
  actionDisabled = false,
  isTeacher = false,

  isFavorite,
  cardType,
}) => {
  const [currentTab, setCurrentTab] = useState('1');
  const [investigationId, setInvestigationId] = useState();
  const [loading, setLoading] = useState(true);
  // const [pdfLoading, setPdfLoading] = useState<boolean>(false);
  // const skeleton = useMemo(() => <CustomInvestigationLoadingV2 />, []);



  useEffect(() => {
    if (data?.id) {
      setInvestigationId(data.id);
      setLoading(false);
    }
  }, [data]);
  

 
  

  const renderTabContent = () => {
    switch (currentTab) {
      case '1':
        return (
          <InvestigationTab
            data={data}
            cloneText={cloneText}
            loading={loading}
            action={action}
            actionText={actionText}
            showPreview={showPreview}
            isTeacher={isTeacher}
            isActive={isActive}
            setFullScreen={setFullScreen}
            closeFullScreen={closeFullScreen}
          />
        );
      case '2':
        return <StandardTab investigationId={investigationId}  isTeacher={isTeacher} isActive={isActive} setFullScreen={setFullScreen} closeFullScreen={closeFullScreen} />;
      case '3':
        return <MaterialTab investigationId={investigationId} kitUrl={data.kitUrl} isTeacher={isTeacher} isActive={isActive} setFullScreen={setFullScreen} closeFullScreen={closeFullScreen}/>;
      case '4':
        return <TeacherNotesTab pdfUrl={data?.teacherNotesPdf} isTeacher={isTeacher} isActive={isActive} setFullScreen={setFullScreen} closeFullScreen={closeFullScreen}/>;

      default:
        return null;
    }
  };

  return (
    <S.CardContainer isTeacher={isTeacher} className={`${isActive ? 'fullview' : ''}`}>
      <S.StyledTabs
        onChange={(value) => {
          setCurrentTab(value);
  
        }}
        defaultActiveKey={currentTab}
        tabBarGutter={8}>
        <S.TabPane tab="Investigation" key="1" />
        <S.TabPane tab="Standards" key="2" />
        {!isTeacher && <S.TabPane tab="Materials" key="3" />}
        <S.TabPane tab="Teacher Notes" key="4" />
      </S.StyledTabs>




      {renderTabContent()}
    </S.CardContainer>
  );
};


export default InvestigationListPageCard;
